export default __webpack_public_path__ + "static/media/nest.cc58894e.svg";